module.exports = __webpack_public_path__ + "static/media/low-2.98f72b70.png";